import { FC } from "react";
import { Tabs as AntTabs, TabsProps as AntTabsProps } from "antd";
import { clsx } from "clsx";
import classes from "./Tabs.module.less";

export interface TabsProps extends AntTabsProps {}

export const Tabs: FC<AntTabsProps> = ({ className, ...props }) => {
    return <AntTabs {...props} className={clsx(classes.tabs, className)} />;
};

Tabs.displayName = "Tabs";
